import { Spinner as ChakraSpinner } from '@chakra-ui/react';
import { forwardRef } from 'react';

import { SpinnerDefaultProps, type SpinnerProps } from './Spinner.types';

const Spinner = forwardRef<HTMLDivElement, SpinnerProps>(({ ...props }, ref) => {
  return (
    <ChakraSpinner
      ref={ref}
      role="status"
      aria-label="Loading"
      color="blue.600"
      css={{ '--spinner-track-color': 'colors.gray.300' }}
      {...props}
    />
  );
});

Spinner.displayName = 'Spinner';
Spinner.defaultProps = SpinnerDefaultProps;

export { Spinner };
